<template>
  <div class="header">
    <div class="logo" ><img src="../assets/logo/logo_new.jpg" alt="" /></div>
    <div class="menu">
      <div class="sidebar cantselect">
        <el-menu
          class="sidebar-el-menu"
          :default-active="onRoutes"
          text-color="#303133"
          active-text-color="#409EFF"
          unique-opened
          router
          mode="horizontal"
        >
          <template v-for="item in items" :key="item.sysmenu">
            <template v-if="item.subs">
              <el-submenu :index="item.sysmenu" key="item-has-subs-{{ item.sysmenu }}">
                <template #title>
                  <i :class="item.menuicon"></i>
                  <span>{{ item.menutext }}</span>
                </template>
                <template v-for="subItem in item.subs">
                  <el-submenu
                    v-if="subItem.subs"
                    :index="subItem.sysmenu"
                    :key="subItem.sysmenu"
                  >
                    <template #title>{{ subItem.menutext }}</template>
                    <el-menu-item
                      v-for="(threeItem, i) in subItem.subs"
                      :key="i"
                      :route="threeItem.router"
                      :index="threeItem.sysmenu"
                      >{{ threeItem.menutext }}</el-menu-item
                    >
                  </el-submenu>
                  <el-menu-item
                    v-else
                    :index="subItem.sysmenu"
                    :route="subItem.router"
                    :key="subItem.sysmenu"
                    >{{ subItem.menutext }}</el-menu-item
                  >
                </template>
              </el-submenu>
            </template>
            <template v-else>
              <el-menu-item
                :index="item.sysmenu"
                :route="item.router"
                :key="item.sysmenu"
              >
                <i :class="item.menuicon"></i>
                <span>{{ item.menutext }}</span>
              </el-menu-item>
            </template>
          </template>
        </el-menu>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {
      company_sn:"R",
      items: [
        {
          sysmenu: "home",
          menutext: "首頁",
          router: "/home",
        },
        {
          sysmenu: "200",
          menutext: "產品展示",
          subs: [
            {
              sysmenu: "cd",
              menutext: "彈簧床墊",
              router: "/goods/cd",
            },
            {
              sysmenu: "cp",
              menutext: "椰棕床褥",
              router: "/goods/cp",
            },
            {
              sysmenu: "cp1",
              menutext: "超力膠床褥",
              router: "/goods/cp1",
            },
            {
              sysmenu: "sf",
              menutext: "梳化床",
              router: "/goods/sf",
            },
          ],
        },
        {
          sysmenu: "about",
          menutext: "品牌文化",
          router: "/about",
        },
        {
          sysmenu: "contact",
          menutext: "聯繫我們",
          router: "/contact",
        },
      ],
    };
  },
  computed: {
    onRoutes() {
      return this.$route.path.replace("/", "");
    },
  },
  created(){
    if(sessionStorage.getItem("company_sn")!=null){
      this.company_sn=sessionStorage.getItem("company_sn")
    }else{
      sessionStorage.setItem("company_sn",this.company_sn);
      var t
      clearTimeout(t)
      var _that=this
      t=setTimeout(function(){
        _that.$router.go(0);
      },500
      )

    }
  },
  methods: {
    qiehuan(id){
      if(id=='R'){
        this.company_sn='S'
        sessionStorage.setItem("company_sn", "S");
      }else{
        this.company_sn='R'
        sessionStorage.setItem("company_sn","R");
      }
      var t
      clearTimeout(t)
      var _that=this
      t=setTimeout(function(){
        _that.$router.go(0);
      },500
      )
    }
  },
};
</script>

<style scoped>
.el-menu.el-menu--horizontal {
  border-bottom: 0px;
  font-size: 50px;
}
.header {
  display: flex;
  height: 100px;
  width: 100%;
  justify-content: center;
}
.logo {
  width: 280px;
  padding-top: 0px;
  margin-right:50px;
}
.logo img {
  width: 280px;
  height: 110px;
}

.logo-wz {
  height: 80px;
  width: 160px;
  padding-top: 25px;
  margin-right: 180px;
}
.logo-wz-title {
  font-size: 28px;
  font-family: Verdana, Geneva, Tahoma, sans-serif;
  color: #409eff;
}
.logo-wz-subtitle {
  font-size: 12px;
  color: #409eff;
}

.menu {
  width: 400px;
  height: 100px;
  line-height: 100px;
}
.sidebar {
  margin-top: 14px;
}
.mc{
  height: 90px;
  line-height: 90px;
  font-size: 14px;
}
</style>